import { reportCommandStartEvent } from '@wix/cli-telemetry';
import type { Command } from '@commander-js/extra-typings';
import { cwd } from 'node:process';
import type { CommandServices } from '@wix/cli-command-contract';
import type { ProjectModel } from '../model.js';
import { loadProjectModel } from '../model.js';

async function initServices(
  { metaSiteId }: ProjectModel,
  { biLogger, errorReporter }: CommandServices
) {
  errorReporter.setContext('site info', {
    siteId: metaSiteId,
  });

  biLogger.updateDefaults({
    _msid: metaSiteId,
  });
}

export async function runCommand(
  command: Command<unknown[]>,
  services: CommandServices,
  cliVersion: string,
  commandFn: (model: ProjectModel) => Promise<void>
) {
  const model = await loadProjectModel(cwd());

  await initServices(model, services);

  const commandStatus = reportCommandStartEvent({
    biLogger: services.biLogger,
    command,
    cliVersion,
    flow: 'Sites',
  });

  try {
    await commandFn(model);
    commandStatus.succeed();
  } catch (e) {
    commandStatus.failed(e);
    throw e;
  }
}
